import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaPopover from './VaPopover.vue'

export const VaPopover = withConfigTransport(_VaPopover)
